import { useEffect, useState } from "react";
import { Container } from '@mui/material';
import { NavLink, useParams } from "react-router-dom";
import { IVendorLight } from "../../../types/vendor";
import { VendorService } from "../../../services/vendorService";

import { IExpense, IExpenseEntity } from "../../../types/expense";

import { ExpenseService } from "../../../services/expenseService";
import { useUserContext } from "../../../contexts/userContext";
import { useListContext } from "../../../contexts/listContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import Spinner from "../../spinner";
import { Icons } from "../../icons";
import ExpenseEditForm from "../../forms/expenseEditForm";
import ExpenseVendorForm from "../../forms/expenseVendorForm";
import { TransporterService } from "../../../services/transporterService";
import { ITransporterLight } from "../../../types/transporter";
import ExpenseTransporterForm from "../../forms/expenseTransporterForm";

const ExpenseEdit = () => {
	const userContext = useUserContext();
	const listContext = useListContext();
	let { id } = useParams();
	const [expense, setExpense] = useState<IExpense>();
	const [vendorOptions, setVendorOptions] = useState<IVendorLight[]>([]);
	const [isLoadingVendorOptions, setIsLoadingVendorOptions] = useState<boolean>(true);
	const [transporterOptions, setTransporterOptions] = useState<ITransporterLight[]>([]);
	const [isLoadingTransporterOptions, setIsLoadingTransporterOptions] = useState<boolean>(true);
	const [activeTab, setActiveTab] = useState("details");
	const [isLoadingExpense, setIsLoadingExpense] = useState(true);
	const [isInitialLoad, setIsInitialLoad] = useState(true);

	useEffect(() => {
		getExpense();
		getVendors();
		getTransporters();
	}, [])

	const getExpense = async () => {
		if (id) {
			ExpenseService.getExpense(id)
				.then((response) => {
					console.log('ExpenseService.getExpense: SUCCESS', response);
					setExpense(ExpenseService.mapExpense(response.data));
				})
				.catch((error) => {
					console.log('ExpenseService.getExpense: ERROR', error);
				})
				.finally(() => {
					setIsLoadingExpense(false);
					setIsInitialLoad(false);
				});
		}
	}

	const getVendors = () => {
		VendorService.getActiveVendors()
			.then((response) => {
				console.log('VendorService.getActiveVendors: SUCCESS', response);
				setVendorOptions(VendorService.mapVendorLightList(response.data));
			})
			.catch((error) => {
				console.log('VendorService.getActiveVendors: ERROR', error);
				setVendorOptions([]);
			})
			.finally(() => {
				setIsLoadingVendorOptions(false);
			});
	}

	const getTransporters = () => {
		TransporterService.getTransporters()
			.then((response) => {
				console.log('TransporterService.getTransporters: SUCCESS', response);
				setTransporterOptions(TransporterService.mapTransporterLightList(response.data));
			})
			.catch((error) => {
				console.log('TransporterService.getTransporters: ERROR', error);
				setTransporterOptions([]);
			})
			.finally(() => {
				setIsLoadingTransporterOptions(false);
			});
	}

	const handleAssignedEntitiesChanged = (entityTypeId: number, assignedEntities: IExpenseEntity[]) => {
		// Assignments have already been saved, just update the local state to reflect the new assignments
		const assignments = expense?.assignedEntities?.filter(e => e.entityTypeId != entityTypeId).concat(assignedEntities) ?? assignedEntities;
		setExpense({ ...expense, assignedEntities: assignments });
	}

	return (
		<div className="hwi-expense-edit">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageExpenses}>
					<>
						<Spinner dependency={isLoadingExpense && isInitialLoad} text="Loading expense...">
							<section className="management-page-header">
								<div className="title">
									<NavLink to="/expense">
										<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
									</NavLink>
									{expense?.name}
								</div>
								<div className="tabs">
									<div className={activeTab == "details" ? "tab active" : "tab"} onClick={() => setActiveTab("details")}>Details</div>
									<div className={activeTab == "vendors" ? "tab active" : "tab"} onClick={() => setActiveTab("vendors")}>Vendors</div>
									<div className={activeTab == "transporters" ? "tab active" : "tab"} onClick={() => setActiveTab("transporters")}>Transporters</div>
								</div>
							</section>
							<Spinner dependency={isLoadingExpense} text="Loading expense...">
								{(activeTab == "details" && expense) &&
									<ExpenseEditForm action="edit" expense={expense} reloadData={getExpense}></ExpenseEditForm>
								}
								{activeTab == "vendors" &&
									<Spinner dependency={isLoadingVendorOptions} text="Loading vendors...">
										<ExpenseVendorForm
											expense={expense}
											entities={vendorOptions}
											isLoadingEntities={isLoadingVendorOptions}
											onAssignedEntitiesChanged={handleAssignedEntitiesChanged} />
									</Spinner>
								}
								{activeTab == "transporters" &&
									<ExpenseTransporterForm
										expense={expense}
										entities={transporterOptions}
										isLoadingEntities={isLoadingTransporterOptions}
										onAssignedEntitiesChanged={handleAssignedEntitiesChanged} />
								}
							</Spinner>
						</Spinner>
					</>
				</PermissionGate>
				{/* <Json data={customer}></Json> */}
			</Container>
		</div>
	);
};

export default ExpenseEdit;


